<ng-container *transloco="let t">
    <div class="px-4 sm:px-16 space-background p-8">
        <div class="flex flex-row" *ngIf="!mobile">
            <!--Left Pane-->
            <div class="basis-1/2 m-auto">
                <div class="text-primary text-4xl font-bold p-36 text-center my-40" [innerHTML]="item.i18nTitleKey|
                    transloco"></div>
            </div>
            <!--Right pane-->
            <div class="basis-1/2 m-auto">
                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 content-center">
                    <ng-container *ngFor="let point of item?.points">
                        <div class="flex flex-row">
                            <!--Icon-->
                            <div class="basis-1/6">
                                <img [src]="point?.imageUrl" class="w-16">
                            </div>
                            <!--text-->
                            <div class="flex flex-col ml-2 basis-5/6">
                                <!--Title-->
                                <div class="font-medium text-lg">{{t(point?.i18nKeyTitle)}}</div>
                                <!--Description-->
                                <div>{{t(point?.i18nDescription)}}</div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="flex flex-row" *ngIf="mobile">
            <div class="flex flex-col w-full">
                <h1 class="text-primary text-2xl sm:text-3xl font-bold text-center" [innerHTML]="item.i18nTitleKey|
                transloco"></h1>
                <mat-accordion class="mt-8" [displayMode]="'flat'">
                    <mat-expansion-panel *ngFor="let point of item?.points;  trackBy: trackByFn">
                        <mat-expansion-panel-header [collapsedHeight]="'56px'">
                            <mat-panel-title class="font-medium leading-tight mb-2">
                                <img [src]="point?.imageUrl" class="w-12 p-1">
                                <p>{{t(point?.i18nKeyTitle)}}</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="mt-2 text-white"> {{t(point?.i18nDescription)}}</div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>

    </div>
</ng-container>